import React from 'react';
export function DefinitionsSection() {
  return <div className="grid md:grid-cols-2 gap-8" data-id="element-3460">
      <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-3461">
        <h3 className="text-2xl font-bold text-navy mb-4 border-b border-gray-200 pb-4" data-id="element-3462">
          What Is A Fiber Laser Cutting Machine?
        </h3>
        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-3463">
          The working principle of fiber laser cutting is to focus the power of
          a high-power laser onto the surface of the material to be cut. The
          energy in the laser beam is absorbed to the surface of the material,
          and the energy of the laser is converted into heat, thereby melting or
          evaporating the material. In addition, gas is focused or blown into
          the cutting area to expel or blow away molten material.
        </p>
      </div>

      <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-3464">
        <h3 className="text-2xl font-bold text-navy mb-4 border-b border-gray-200 pb-4" data-id="element-3465">
          What Is A Plasma Cutting Machine?
        </h3>
        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-3466">
          Plasma cutting is the oldest form of cutting. Its history can be
          traced back to the 1950s and is an alternative to flame cutting.
          Plasma cutting is performed by jetting superheated ionized gas (ie
          plasma) from a nozzle toward the workpiece at a high speed. Then an
          arc is formed in the gas. The arc ionizes part of the gas, thereby
          forming a conductive channel for the plasma in the process. When the
          electricity from the torch travels down the plasma, it generates
          enough heat to melt through the workpiece. The plasma and compressed
          gas blow away the hot molten metal, causing the workpiece to separate.
        </p>
      </div>
    </div>;
}